import Entity from "./Entity";

export default class MapOpeningMessage extends Entity {
    constructor(data) {
        super(data);

        this.setAttributeKeys([
            "id", "title", "message", "active", "startDate", "endDate", "frequency", "mapIds", "lastUpdate"
        ]);
    }

    getId() {
        return this.get("id");
    }
}